import React from "react";
import styled from "styled-components";
import lastCallLogo from "../../assets/logo.png";
import Logout from "../oauth/logout";
import BestPracticesDialog from "./BestPracticesDialog";
import AccountSwitcher from "./AccountSwitcher";
import { useAccount } from '../../contexts/AccountContext';
import Profile from "../Profile/Profile";
const HeaderContainer = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 0 24px;
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding-right: 16px;
`;

const Header = () => {
    const { userData, setUserData } = useAccount();

    const makeAdmin = () => {
        setUserData({
            ...userData,
            isAdmin: true
        });
    };

    return (
        <HeaderContainer>
            <img
                src={lastCallLogo}
                alt="LastCall Logo"
                style={{
                    height: "15vh",
                    width: "auto",
                    objectFit: "contain",
                    maxWidth: "30%",
                }}
            />
            <RightSection>
                
                <BestPracticesDialog />
                <AccountSwitcher />
                <Profile />
            </RightSection>
            {process.env.REACT_APP_ENV === 'development' && (
                <button 
                    onClick={makeAdmin}
                    style={{ 
                        position: 'fixed', 
                        bottom: 20, 
                        right: 20,
                        padding: '8px 16px',
                        background: '#666',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Make Admin (Dev Only)
                </button>
            )}
        </HeaderContainer>
    );
};

export default Header;